<!-- <header-root></header-root> -->
<div class="green-corner">
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 456.84 259.17">
    <defs>
      <linearGradient id="a" x1="489.6" y1="435.41" x2="299.29" y2="767.12" gradientUnits="userSpaceOnUse">
        <stop offset="0" class="gradient__primary-color" />
        <stop offset="1" class="gradient__primary-color-dark" />
      </linearGradient>
      <linearGradient id="b" x1="339.93" y1="468.23" x2="700.8" y2="468.23" gradientUnits="userSpaceOnUse">
        <stop offset="0.02" stop-color="#3b919d" />
        <stop offset="0.55" stop-color="#49d4c1" />
        <stop offset="0.87" stop-color="#aaf16f" />
        <stop offset="0.89" stop-color="#b8f25c" />
        <stop offset="0.94" stop-color="#d4f438" />
        <stop offset="0.98" stop-color="#e6f621" />
        <stop offset="1" stop-color="#ecf619" />
      </linearGradient>
    </defs>
    <path class="a" d="M293.9,547H450.35l-54.28-68.91,65.44-51.55c29-21.38,67.41-18.51,86.79,6.09,19.84,24.23,16.48,66.75-10.64,89.62L506.24,547H673.76c26.33-61,20.41-131.62-23.41-187.24-64-81.22-182.64-95.31-267.35-33.84l-65.44,51.55-69.62,54.85-4.18,3.29c-13,10.24-14.8,29-4.19,42.42Z" transform="translate(-232.67 -287.83)" />
    <path class="b" d="M548.76,432.27c19.38,24.59,16,67.11-11.1,90L506.24,547H672.71c12.2-28.42,14.6-52.15,14.9-61.65.75-13.37-10.43-36.16-19.57-47.76-49.36-62.66-142.48-61.51-205.6-11.78l-.47.36C491,404.8,529.38,407.67,548.76,432.27Z" transform="translate(-232.67 -287.83)" />
  </svg>
</div>
<div class="logo-corner"></div>

<div class="login-background">
  <div class="container-box">
    <div id="login-view" class="form-section" [class.extra-grid]="showQrCode">
      <div>
        <b>{{ 'two_factor_title' | translate }}</b>
        <p *ngIf="showQrCode" class="hint">{{ 'two_factor_hint_qr' | translate }}</p>
      </div>

      <ng-container *ngIf="showQrCode">
        <img class="qr" src="{{qrCode}}">
        <div class="qr-text-code">{{authenticatorCode}}</div>
      </ng-container>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'authenticator_code' | translate }}</mat-label>
        <input matInput type="text" [formControl]="password" autocomplete="off" (keyup)="handleKeyUp($event)">
      </mat-form-field>

      <div class="grid-buttons">
        <button class="login-button" (click)="login()">
          <span *ngIf="!loading">{{ 'login_button' | translate }}</span>
          <span *ngIf="loading">{{ 'logging_in_button' | translate }}</span>
        </button>
        <a class="button" (click)="goBack()">{{ 'back_button' | translate }}</a>
      </div>

      <div *ngIf="!logged" class="validation-summary-errors">
        <ul>
          <li *ngIf="error == 1"><mat-error>{{ 'error_user_not_exist' | translate }}</mat-error></li>
          <li *ngIf="error == 2"><mat-error>{{ 'error_user_not_active' | translate }}</mat-error></li>
          <li *ngIf="error == 3"><mat-error>{{ 'error_client_not_active' | translate }}</mat-error></li>
          <li *ngIf="error == 4"><mat-error>{{ 'error_no_licenses' | translate }}</mat-error></li>
          <li *ngIf="error == 5"><mat-error>{{ 'error_too_many_designers' | translate }}</mat-error></li>
          <li *ngIf="error == 6"><mat-error>{{ 'error_too_many_technicians' | translate }}</mat-error></li>
          <li *ngIf="error == 7"><mat-error>{{ 'error_pwd' | translate }}</mat-error></li>
          <li *ngIf="error == 9"><mat-error>{{ 'error_two_factor' | translate }}</mat-error></li>
        </ul>
      </div>
    </div>

    <div class="logo-section">
      <div class="login-logo"></div>
    </div>
  </div>
</div>
